import { Component, OnDestroy, OnInit } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";
import { LoadingDrivebService } from "./loading-driveb.service";
import { assetUrl } from "@shared/helper/asset-url";
import { FeatureToggleService } from "@core/services/feature-toggle.service";
import { AppConfigService } from "@core/services/app-config.service";
import { ConfigurationPolicyCompleteDTO } from "@core/models/app-config.model";

@Component({
  selector: "app-driveb-loading-driveb",
  templateUrl: "./loading-driveb.component.html",
  styleUrls: ["./loading-driveb.component.scss"],
  standalone: false
})
export class LoadingDrivebComponent implements OnInit, OnDestroy {
  show = false;
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  favIcon$: string;
  config$: Observable<ConfigurationPolicyCompleteDTO>;

  constructor(
    private _loadingDrivebService: LoadingDrivebService,
    private configService: AppConfigService
  ) {}

  ngOnInit() {
    this._loadingDrivebService.show$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((value) => {
        this.show = value;
      });

    this.getLoadingIcon();
    this.config$ = this.configService.getConfig$();
  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  private getLoadingIcon() {
    this.favIcon$ = assetUrl("img/favicon/favicon.png");
  }
}
